<script setup lang="ts">
    import { __ } from '@/js/stores/expressions';
    import { computed } from 'vue';

    const props = defineProps<{
        points: number;
        maxPoints: number;
    }>();

    const percentage = computed(() => {
        const sectionPoints = props.points;
        if (!sectionPoints || props.maxPoints === 0) {
            return 0;
        }
        return Number((props.points / props.maxPoints) * 100).toFixed(0);
    });

    const totalLabel = computed(
        () =>
            `${props.points} ${__('coaching-form-points-of')} ${props.maxPoints}, ${percentage.value}%`
    );
</script>
<template>
    <div class="flex items-center">
        <div class="mr-4 text-body" aria-hidden="true">{{ __('total-result') }}:</div>
        <div
            class="rounded-md border border-gray-light text-gray-dark text-body-bold flex py-2 items-center"
            aria-hidden="true"
        >
            <div class="px-4">
                {{ props.points }}
                {{ __('coaching-form-points-of') }}
                {{ props.maxPoints }}
            </div>
            <div class="border-l border-gray-light px-4">{{ percentage }}%</div>
        </div>
        <span class="sr-only">{{ __('total-result') }}: {{ totalLabel }}</span>
    </div>
</template>
